var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user_orders_Settings" },
    [
      _c("div", { staticClass: "intro" }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.__t("pwa.intro")) + "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-tabs",
        { attrs: { pills: "", card: "", vertical: "" } },
        _vm._l(_vm.pwa_res, function (item, idx) {
          return _c(
            "b-tab",
            {
              key: item.comp,
              attrs: { "title-link-class": "", active: item.is_active },
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "fs-lg px-4 text-center" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.name) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-card-text",
                [
                  _c(item.comp, {
                    tag: "component",
                    attrs: { client_id: _vm.user.client_id },
                  }),
                ],
                1
              ),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }